enum EnvType {
  PRODUCTION = 'PRODUCTION',
  DEVELOP = 'DEVELOP',
}

export default EnvType;
